import React from 'react'

export default function Footer() {
    return (
        <footer className="w-full border-t text-xs font-thin flex justify-center">
            <a target="_blank" rel="noreferrer noopener" className="p-4" href="https://docs.vechain.energy/vechain.energy/Oracles/">About</a>
            <a target="_blank" rel="noreferrer noopener" className="p-4" href="https://vechain.energy">Provided with ❤️ by vechain.energy</a>
            <a target="_blank" rel="noreferrer noopener" className="p-4" href="https://github.com/vechain-energy/oracle.vechain.energy">GitHub</a>
        </footer>
    )
}